import type { ReactNode } from "react";

// Shared by the campaign existing-users screens (audience modal, recipients drawer).
export type Toast = { showError: (m: string) => void; showSuccess: (m: string) => void };

export function Stat({ label, value, tone }: { label: string; value: ReactNode; tone?: string }) {
  return (
    <div className="bg-gray-800/60 border border-gray-800 rounded-lg px-3 py-2">
      <div className="text-xs text-gray-500">{label}</div>
      <div className={`text-lg font-semibold ${tone ?? "text-white"}`}>{value}</div>
    </div>
  );
}

export const SKIP_LABEL: Record<string, string> = {
  unverified: "Not verified",
  disabled: "Disabled accounts",
  restricted: "Restricted accounts",
  not_onboarded: "Not onboarded yet",
  already_received: "Already received",
};
